// `service-requests.*` (menu item 70). `index` also covers the detail drawer and the
// matching-units panel — the backend registers no separate `show`.
export const SERVICE_REQUESTS_INDEX = 1659;
export const SERVICE_REQUESTS_UPDATE_STATUS = 1660;
export const SERVICE_REQUESTS_CONVERT = 1661;
export const SERVICE_REQUESTS_DELETE = 1662;
export const SERVICE_REQUESTS_RESTORE = 1663;
